import { create } from "zustand";

export const mapStore = create((set) => ({
    map: null,
    setMap: (data) => set({ map: data }),
}));